import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Introduction from "./components/Introduction";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import AboutMe from "./components/AboutMe";
import Chatbot from "./components/Chatbot";
import "./App.css";
import ReactGA from "react-ga";

const App = () => {
  const [activeSection, setActiveSection] = useState('home');

  // Initialize Google Analytics only once
  useEffect(() => {
    ReactGA.initialize("UA-63454306-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    console.log(
      "%cHey there, curious person! Thanks for checking under the hood. This is my site. Built with care.\nHopefully there aren't any errors above these lines. 🙂\nIf you see some, send me an email, would you please?",
      "color: #4e54c8; font-size: 1.1em; line-height: 1.4;"
    );
  }, []);

  // Track previous section to detect changes
  const previousSectionRef = React.useRef('home');

  // Custom scroll tracking
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'projects', 'contact'];
      const headerHeight = document.getElementById('navbar')?.offsetHeight || 80;
      const scrollPosition = window.scrollY + headerHeight + 20; // More accurate offset

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionBottom = sectionTop + section.offsetHeight;
          
          // Check if we're in this section
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            const newSection = sections[i];
            if (newSection !== activeSection) {
              setActiveSection(newSection);
              
              // Track section visit (only when section actually changes)
              if (previousSectionRef.current !== newSection) {
                ReactGA.event({
                  category: 'navigation',
                  action: 'section_viewed',
                  label: newSection,
                  value: 1
                });
                previousSectionRef.current = newSection;
              }
            }
            break;
          }
        }
      }
    };

    // Handle hash changes (when clicking navigation links)
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash && ['home', 'about', 'projects', 'contact'].includes(hash)) {
        setActiveSection(hash);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('hashchange', handleHashChange);
    
    // Check initial hash
    handleHashChange();
    // Check initial scroll position after a short delay to ensure DOM is ready
    setTimeout(handleScroll, 100);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('hashchange', handleHashChange);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty deps - scroll handler should only set up once

  return (
    <div className="app">
      <Header activeSection={activeSection} />
      <div id="home">
        <Introduction />
      </div>
      <div id="about">
        <AboutMe />
      </div>
      <div id="projects">
        <Projects />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <Chatbot 
        position="bottom-right"
        primaryColor="#7c3aed"
      />
    </div>
  );
};

export default App;
